// Mirrors api/utils/index.js's applyPinAffix - applies a domain's configured PIN prefix/suffix
// (e.g. "#") to a raw PIN for display purposes only.
const applyPinAffix = (pin, domain) => {
	const affix = domain?.pinCodeSuffix || '';
	if (!pin || !affix) return pin;
	return domain?.pinAffixPosition === 'prefix' ? `${affix}${pin}` : `${pin}${affix}`;
};

export default applyPinAffix;
